import { __decorate } from "tslib";
import Avatar from '@/components/Avatar.vue';
import Money from '@/components/Money.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import { modalMixins } from '@/mixins/modal.js';
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
let SimpleTable = class SimpleTable extends Vue {
    columns;
    actions;
    loading;
    hideDeleteButton;
    bulkActions;
    data;
    edit;
    deleteItem;
    onSort;
    rowButtons;
    selected;
    selector;
    sort = 'createdAt';
    order = -1;
    model = {};
    get columnsCount() {
        let columnsCount = this.columns.length;
        if (this.actions)
            columnsCount++;
        return columnsCount;
    }
    get isEverythingSelected() {
        const selectedCount = new Set(this.selected).size;
        const allCount = new Set(this.data.map(this.selector)).size;
        return selectedCount === allCount;
    }
    emitSelected(val) {
        return val;
    }
    couldBeViewed(item) {
        return true;
        // if (!this.edit) return false;
        // return !!(item.can_vuew);
    }
    couldBeEdited(item) {
        return item.blocked !== true;
    }
    couldBeDeleted(item) {
        // if (!this.delete) return false;
        return !!(item.can_delete);
    }
    formatDate(date, format) {
        return this.$moment.utc(date).local().format(format);
    }
    unix(date) {
        return this.$moment.utc(date).local().unix();
    }
    columnClass(column, item) {
        return [{ 'pointer': column.link || column.click }, typeof column.classes === 'function' ? column.classes(item) : column.classes];
    }
    columnStyle(column) {
        const defaultStyle = {
            'white-space': 'nowrap',
            'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'max-width': '150px'
        };
        if (!column.style)
            return defaultStyle;
        if (column.style.overwrite)
            return column.style.value;
        return [defaultStyle, column.style.value];
    }
    getUserName(item) {
        if (item.first_name || item.last_name)
            return { first_name: item.first_name, last_name: item.last_name };
        if (item.firstName || item.lastName)
            return { firstName: item.firstName, lastName: item.lastName };
    }
    selectAll(val) {
        if (val) {
            let selected = new Set(this.selected); // this makes sure only unique values are being added
            for (let item of this.data) {
                selected.add(this.selector(item));
            }
            this.emitSelected(Array.from(selected));
        }
        else {
            this.emitSelected([]);
        }
    }
};
__decorate([
    Prop({ type: Array, required: true })
], SimpleTable.prototype, "columns", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], SimpleTable.prototype, "actions", void 0);
__decorate([
    Prop({ type: Boolean })
], SimpleTable.prototype, "loading", void 0);
__decorate([
    Prop({ type: Boolean })
], SimpleTable.prototype, "hideDeleteButton", void 0);
__decorate([
    Prop({ type: Boolean })
], SimpleTable.prototype, "bulkActions", void 0);
__decorate([
    Prop({ type: Array })
], SimpleTable.prototype, "data", void 0);
__decorate([
    Prop({ type: [Function, Boolean] })
], SimpleTable.prototype, "edit", void 0);
__decorate([
    Prop({ type: [Function, Boolean] })
], SimpleTable.prototype, "deleteItem", void 0);
__decorate([
    Prop({ type: Function })
], SimpleTable.prototype, "onSort", void 0);
__decorate([
    Prop({ type: Array })
], SimpleTable.prototype, "rowButtons", void 0);
__decorate([
    Prop({ type: Array })
], SimpleTable.prototype, "selected", void 0);
__decorate([
    Prop({ type: Function, default: (item) => item._id })
], SimpleTable.prototype, "selector", void 0);
__decorate([
    Emit('update:selected')
], SimpleTable.prototype, "emitSelected", null);
SimpleTable = __decorate([
    Component({
        mixins: [modalMixins],
        components: {
            Avatar,
            Money,
            ConfirmationModal
        }
    })
], SimpleTable);
export default SimpleTable;
